import { GET_READING_TEMPLATES_WITH_TITLE } from 'apollo/queries';
import { useAuthQuery } from 'utils/hooks';

export const useGetReadingTemplates = () => {
  const { data } = useAuthQuery(GET_READING_TEMPLATES_WITH_TITLE);
  const { readingTemplates = [] } = { ...data };

  return { readingTemplates };
};
